const types = {
  //Get LabVisitor List
  GET_LAB_VISITOR_START: "GET_LAB_VISITOR_START",
  GET_LAB_VISITOR_SUCCESS: "GET_LAB_VISITOR_SUCCESS",
  GET_LAB_VISITOR_ERROR: "GET_LAB_VISITOR_ERROR",
  GET_LAB_VISITOR_RESET: "GET_LAB_VISITOR_RESET",

  //Create LabVisitor
  CREATE_LAB_VISITOR_START: "CREATE_LAB_VISITOR_START",
  CREATE_LAB_VISITOR_SUCCESS: "CREATE_LAB_VISITOR_SUCCESS",
  CREATE_LAB_VISITOR_ERROR: "CREATE_LAB_VISITOR_ERROR",
  CREATE_LAB_VISITOR_RESET: "CREATE_LAB_VISITOR_RESET",

  //Update LabVisitor
  UPDATE_LAB_VISITOR_START: "UPDATE_LAB_VISITOR_START",
  UPDATE_LAB_VISITOR_SUCCESS: "UPDATE_LAB_VISITOR_SUCCESS",
  UPDATE_LAB_VISITOR_ERROR: "UPDATE_LAB_VISITOR_ERROR",
  UPDATE_LAB_VISITOR_RESET: "UPDATE_LAB_VISITOR_RESET",

  //Delete LabVisitor
  DELETE_LAB_VISITOR_START: "DELETE_LAB_VISITOR_START",
  DELETE_LAB_VISITOR_SUCCESS: "DELETE_LAB_VISITOR_SUCCESS",
  DELETE_LAB_VISITOR_ERROR: "DELETE_LAB_VISITOR_ERROR",
  DELETE_LAB_VISITOR_RESET: "DELETE_LAB_VISITOR_RESET",

  //Single LabVisitor
  SINGLE_LAB_VISITOR_START: "SINGLE_LAB_VISITOR_START",
  SINGLE_LAB_VISITOR_SUCCESS: "SINGLE_LAB_VISITOR_SUCCESS",
  SINGLE_LAB_VISITOR_ERROR: "SINGLE_LAB_VISITOR_ERROR",
  SINGLE_LAB_VISITOR_RESET: "SINGLE_LAB_VISITOR_RESET",
};

export default types;
